<template>
  <b-tooltip
    type="is-primary"
    position="is-right"
    :label="label">
    <b-icon
      :icon="icon"
      size="is-small"
      type="is-primary">
    </b-icon>
  </b-tooltip>
</template>

<script>
export default {
  props: {
    sendMail: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: 'is-right',
    },
  },
  computed: {
    icon() {
      return this.sendMail ? 'email-alert' : 'file-document-alert';
    },
    label() {
      return this.$t(`listeFactures.${this.sendMail ? 'factureParEmail' : 'factureParCourrier'}`);
    },
  },
};
</script>
